import dayjs from 'dayjs'

/**
 * Convert ISO date strings in a step/protocol payload back to Dayjs objects.
 * Tauri IPC serializes Dayjs objects to ISO strings via JSON.stringify;
 * on the way back through IPC, dates arrive as strings. This helper
 * rehydrates them so consumers (apiClient, deepMerge, etc.) can treat
 * them as proper Dayjs instances.
 *
 * Only top-level date fields are handled here. Nested objects with dates
 * (e.g. transient.fileData) are not currently affected; add them as
 * needed.
 */
export function convertPayloadDatesToDayjs<T = unknown>(payload: T): T {
    if (!payload || typeof payload !== 'object') return payload
    const result: Record<string, unknown> = { ...(payload as Record<string, unknown>) }
    if (typeof result.startTime === 'string') {
        try { result.startTime = dayjs(result.startTime as string) } catch { /* ignore invalid date */ }
    }
    if (typeof result.endTime === 'string') {
        try { result.endTime = dayjs(result.endTime as string) } catch { /* ignore invalid date */ }
    }
    return result as T
}